module.exports = __webpack_public_path__ + "img/aside_logo4.59d9af30.png";